/* Product-information enhancement only. Native product forms and cart are untouched. */
(() => {
  if (!customElements.get('mamata-product-routine')) {
    customElements.define('mamata-product-routine', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        const signal = this.controller.signal;
        this.addEventListener('click', (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (tab && this.tabs.includes(tab)) this.select(tab);
        }, { signal });
        this.addEventListener('keydown', (event) => {
          const index = this.tabs.indexOf(event.target);
          if (index < 0) return;
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.select(this.tabs[next]);
          this.tabs[next].focus();
        }, { signal });
      }
      select(selected) {
        this.tabs.forEach((tab) => {
          const active = tab === selected;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          const panel = document.getElementById(tab.getAttribute('aria-controls'));
          if (panel && this.contains(panel)) panel.hidden = !active;
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  if (!customElements.get('mamata-pdp-details')) {
    customElements.define('mamata-pdp-details', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const revealTarget = (hash, scroll = false) => {
          if (!hash || !hash.startsWith('#MamataProduct')) return;
          let id;
          try { id = decodeURIComponent(hash.slice(1)); } catch { return; }
          const target = document.getElementById(id);
          if (!target || !this.contains(target)) return;
          let ancestor = target;
          while (ancestor && ancestor !== this) {
            if (ancestor instanceof HTMLDetailsElement) ancestor.open = true;
            ancestor = ancestor.parentElement;
          }
          requestAnimationFrame(() => {
            const focusTarget = target instanceof HTMLDetailsElement ? target.querySelector('summary') : target;
            if (focusTarget) {
              if (!focusTarget.matches('a, button, summary, [tabindex]')) focusTarget.tabIndex = -1;
              focusTarget.focus({ preventScroll: true });
            }
            if (scroll) target.scrollIntoView({ block: 'start' });
          });
        };
        document.addEventListener('click', (event) => {
          if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const link = event.target.closest('a[href^="#MamataProduct"]');
          if (link) revealTarget(link.getAttribute('href'));
        }, { signal });
        window.addEventListener('hashchange', () => revealTarget(window.location.hash, true), { signal });
        this.querySelectorAll('.mamata-pdp-instruction-video').forEach((details) => {
          details.addEventListener('toggle', () => {
            if (!details.open) details.querySelectorAll('video-element').forEach((player) => player.pause?.());
          }, { signal });
          // A player may finish loading after its accordion has already closed.
          details.addEventListener('video:play', (event) => {
            if (!details.open) event.target.pause?.();
          }, { signal });
        });
        revealTarget(window.location.hash, true);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
})();
